import "./MissionVision.module.css";
import Header from "@/reusable_sections/Header";
import TheFoundationStory from "./sections/TheFoundationStory";
import StrategicRoadmap from "./sections/StrategicRoadmap";
import ExecutiveLeadership from "./sections/ExecutiveLeadership";
import Footer from "@/reusable_sections/Footer";
export default function MissionVisionPage() {
  return <div>
      <Header />
      <TheFoundationStory />
      <StrategicRoadmap />
      <ExecutiveLeadership />
      <Footer />
    </div>;
}